import { configureStore } from '@reduxjs/toolkit';

import claimsReducer from './slices/claimsSlice';
import startetReducer from './slices/startetSlice';
import authReducer from '@/store/slices/authSlice';
import casesReducer from '@/store/slices/casesSlice';
import companyReducer from './slices/companySlice';
import importReducer from '@/store/slices/importSlice';
import notificationsReducer from '@/store/slices/notificationsSlice';
import searchReducer from '@/store/slices/searchSlice'

import { useDispatch } from 'react-redux';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    claims: claimsReducer,
    startet: startetReducer,
    cases: casesReducer,
    company: companyReducer,
    import: importReducer,
    notifications: notificationsReducer,
    search: searchReducer,
  },
});

// Создаем типизированный useDispatch
export const useAppDispatch: () => AppDispatch = useDispatch;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
